var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#EEF2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#E0E7FF",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0834 27.7499L41.1667 23.6666M43.5001 21.3333L41.1667 23.6666L43.5001 21.3333ZM32.2884 32.5449C32.8908 33.1393 33.3697 33.847 33.6975 34.6272C34.0252 35.4074 34.1954 36.2447 34.1983 37.091C34.2011 37.9373 34.0365 38.7757 33.714 39.5581C33.3914 40.3405 32.9173 41.0514 32.3189 41.6498C31.7205 42.2482 31.0097 42.7223 30.2273 43.0448C29.4449 43.3674 28.6064 43.532 27.7601 43.5291C26.9139 43.5263 26.0765 43.3561 25.2963 43.0283C24.5161 42.7005 23.8085 42.2216 23.2141 41.6193C22.0452 40.4091 21.3985 38.7882 21.4131 37.1058C21.4277 35.4233 22.1025 33.814 23.2922 32.6242C24.4819 31.4345 26.0913 30.7597 27.7738 30.7451C29.4562 30.7305 31.077 31.3772 32.2872 32.5461L32.2884 32.5449ZM32.2884 32.5449L37.0834 27.7499L32.2884 32.5449ZM37.0834 27.7499L40.5834 31.2499L44.6667 27.1666L41.1667 23.6666L37.0834 27.7499Z",
    stroke: "#3D54CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyicon);
export default __webpack_public_path__ + "static/media/keyicon.a40ebdbfae9baea791d5044509c6549b.svg";
export { ForwardRef as ReactComponent };